import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { AnnouncementsListTable } from './announcements-list-table';

export function AnnouncementsListPage() {
  return (
    <div className='min-w-0'>
      <Link to='/dashboard' className='flex min-w-0 items-center gap-2'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='min-w-0 text-xl font-semibold sm:text-2xl'>
          Announcements
        </h2>
      </Link>
      <p className='mt-2 text-sm text-muted-foreground'>
        Share studio updates with families in the Parent Portal. Announcements
        are in-app only and do not send email or SMS.
      </p>
      <AnnouncementsListTable />
    </div>
  );
}
